export const objectsFilters = [
  {
    category: 1,
    logo: `${process.env.PUBLIC_URL}/assets/img/object_all.svg`,
  },
  {
    category: 2,
    logo: `${process.env.PUBLIC_URL}/assets/img/object_house.svg`,
  },
  {
    category: 3,
    logo: `${process.env.PUBLIC_URL}/assets/img/object_sacred.svg`,
  },
  {
    category: 4,
    logo: `${process.env.PUBLIC_URL}/assets/img/object_museum.svg`,
  },
  {
    category: 5,
    logo: `${process.env.PUBLIC_URL}/assets/img/object_other.svg`,
  },
];
